module.exports = __webpack_public_path__ + "assets/img/3153129f2055731456ef4133c3e4c83a.png";